import path from 'node:path';
import { getBridgeRoot } from '../files/cwd/index.js';
import { normalizeResolvedPath } from '../paths/normalize-resolved-path.js';

export function isBridgeRootCheckoutPath(checkoutPath: string): boolean {
  return normalizeResolvedPath(checkoutPath) === normalizeResolvedPath(getBridgeRoot());
}

/** Session archive/discard removes git worktree checkouts only — never the bridge root itself. */
export function isRemovableSessionWorktreeCheckoutPath(
  checkoutPath: string,
  worktreesRootPath: string,
): boolean {
  if (isBridgeRootCheckoutPath(checkoutPath)) return false;
  const normalized = normalizeResolvedPath(checkoutPath);

  const worktreesRoot = normalizeResolvedPath(worktreesRootPath);
  const rel = path.relative(worktreesRoot, normalized);
  if (rel === '' || rel.startsWith('..') || path.isAbsolute(rel)) return false;
  return true;
}
